import { render, staticRenderFns } from "./AddWindow.vue?vue&type=template&id=2625f80c"
import script from "./AddWindow.vue?vue&type=script&lang=js"
export * from "./AddWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports